export var Variant = /*#__PURE__*/ function(Variant) {
    Variant["text"] = "text";
    Variant["brand"] = "brand";
    Variant["gray"] = "gray";
    return Variant;
}({});
export const buttonVariant = {
    text: 'plain',
    brand: 'tertiary',
    gray: 'tertiaryGray'
};
